
import mixpanel from 'mixpanel-browser';

export const mixpanelMixin = {
    data: function () {
      return {
        _mpLoaded: null,
        _mpKey: null
      };
    },
    methods: {
      mp_init(payload) {
        //console.log('IN MIXPANEL INIT ', payload);
        mixpanel.init(payload);
      },
    //   mp_identify(current_user) {
    //     console.log('IN MIXPANEL IDENITFY ', current_user);
    //     mixpanel.identify(current_user.email);
    //   },
      mp_track(e, payload) {
        mixpanel.track(e, payload);
      }
    }
  }